import React, { useEffect, useState } from "react";
import logo from "../../Assets/images/MSDLogo.png"
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Invoice from "./Invoice";
import html2pdf from 'html2pdf.js';
import Select from 'react-select';
import Handler from "../../Helpers/Components/Handler"
import { reloadWindowToPath } from "../../Helpers/Utils";
import moment from "moment";
import Modal from "../../Helpers/Components/Modal";

const EditInvoice = (props) => {
    const [data, setData] = useState({});
    const [totalDays, setTotalDays] = useState(0)
    const { id } = useParams();
    const [invoiceHtml, setInvoiceHtml] = useState('');
    const [render, setrender] = useState(false);
    const [point, setPoint] = useState({ label: 0, value: 0 })
    const navigate = useNavigate()
    const [gst, setGst] = useState({ gst: 0, gstType: '' })
    const [modal, setModal] = useState(true);
    const downloadFile = (updatedHtmlContent) => {
        setrender(false)
        try {
            const wrapperDiv = document.createElement('div');
            wrapperDiv.innerHTML = updatedHtmlContent;
            const options = {
                padding: 30,
                filename: 'Invoice.pdf',
                image: { type: 'jpeg', quality: 0.98 },
                html2canvas: { scale: 2 },
                jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
            };
            html2pdf(wrapperDiv, options);
        } catch (error) {
            toast.error('Error during PDF download');
        }
    }
    const updateInvoiceContent = async () => {
        const divContent = document.getElementById('invoiceDiv')?.innerHTML;
        const parser = new DOMParser();
        const doc = parser.parseFromString(divContent, 'text/html');
        setrender(true);
        let targetElement = doc.getElementById('book_id');
        if (targetElement) {
            targetElement.innerHTML = id || "-";
        }
        targetElement = doc.getElementById('cust_id');
        if (targetElement) {
            targetElement.innerHTML = data?.booking?.customerId || "-";
        }
        targetElement = doc.getElementById('cust_name');
        if (targetElement) {
            targetElement.innerHTML = (data?.customer?.firstName || "") + " " + (data?.customer?.lastName || "");
        }
        targetElement = doc.getElementById('mobile');
        if (targetElement) {
            let phone = data?.customer?.phone?.length ? data?.customer?.phone?.filter(element => element?.priority === 1) : "";
            targetElement.innerHTML = phone?.phone ? (phone?.code || "") + "-" + (phone?.phone || "") : ""
        }
        targetElement = doc.getElementById('delivery_date');
        if (targetElement) {
            targetElement.innerHTML = data?.booking?.deliveryDetails?.delivery ? moment(new Date(data?.booking?.deliveryDetails?.delivery)).format("DD/MM/YYYY") : ""
        }
        targetElement = doc.getElementById('delivery_time');
        if (targetElement) {
            targetElement.innerHTML = data?.booking?.deliveryDetails?.delivery ? moment(new Date(data?.booking?.deliveryDetails?.delivery)).format("hh:mm A") : ""
        }
        targetElement = doc.getElementById('delivery_location');
        if (targetElement) {
            targetElement.innerHTML = data?.booking?.deliveryDetails?.location || ""
        }
        targetElement = doc.getElementById('pickup_date');
        if (targetElement) {
            targetElement.innerHTML = data?.booking?.pickupDetails?.pickup ? moment(new Date(data?.booking?.pickupDetails?.pickup)).format("DD/MM/YYYY") : ""
        }
        targetElement = doc.getElementById('pickup_time');
        if (targetElement) {
            targetElement.innerHTML = data?.booking?.pickupDetails?.pickup ? moment(new Date(data?.booking?.pickupDetails?.pickup)).format("hh:mm A") : ""
        }
        targetElement = doc.getElementById('pickup_location');
        if (targetElement) {
            targetElement.innerHTML = data?.booking?.pickupDetails?.location || ""
        }
        targetElement = doc.getElementById('rent_per_day');
        if (targetElement) {
            targetElement.innerHTML = data?.rentalFee || ""
        }
        targetElement = doc.getElementById('rent_per_day_total');
        if (targetElement) {
            targetElement.innerHTML = ((Number(data?.booking?.rentalFee || 0) - Number(data?.booking?.offerPerDay || 0)) * (totalDays)) + (point?.label === 0.5 ? ((Number(data?.booking?.rentalFee || 0) / 2) - Number(data?.booking?.halfDayOffer || 0)) : 0)
        }
        targetElement = doc.getElementById('extra_charge');
        if (targetElement) {
            targetElement.innerHTML = Number(data?.booking?.excess?.fuelCharges || 0) + Number(data?.booking?.excess?.kmCharges || 0) + Number(data?.booking?.excess?.timeCharges || 0)
        }
        targetElement = doc.getElementById('extra_charges');
        if (targetElement) {
            targetElement.innerHTML = Number(data?.booking?.excess?.fuelCharges || 0) + Number(data?.booking?.excess?.kmCharges || 0) + Number(data?.booking?.excess?.timeCharges || 0)
        }
        targetElement = doc.getElementById('other_charge');
        if (targetElement) {
            targetElement.innerHTML = Number(data?.booking?.excessCharges?.length ? data?.booking?.excessCharges?.reduce((total, num) => total + Number(num?.amount), 0) : 0) + Number(data?.booking?.deliveryDetails?.price || 0) + Number(data?.booking?.pickupDetails?.price || 0) + Number(Number(data?.booking?.fastTag?.start || 0) - Number(data?.booking?.fastTag?.end || 0) > 0 ? (Number(data?.booking?.fastTag?.start || 0) - Number(data?.booking?.fastTag?.end || 0)) : 0)
        }
        targetElement = doc.getElementById('other_charges');
        if (targetElement) {
            targetElement.innerHTML = Number(data?.booking?.excessCharges?.length ? data?.booking?.excessCharges?.reduce((total, num) => total + Number(num?.amount), 0) : 0) + Number(data?.booking?.deliveryDetails?.price || 0) + Number(data?.booking?.pickupDetails?.price || 0) + Number(Number(data?.booking?.fastTag?.start || 0) - Number(data?.booking?.fastTag?.end || 0) > 0 ? (Number(data?.booking?.fastTag?.start || 0) - Number(data?.booking?.fastTag?.end || 0)) : 0)
        }
        targetElement = doc.getElementById('gst');
        if (targetElement) {
            targetElement.innerHTML = gst?.gst || 0
        }
        targetElement = doc.getElementById('offer_charge');
        if (targetElement) {
            targetElement.innerHTML = data?.booking?.refund?.offer || 0
        }
        targetElement = doc.getElementById('offer_charges');
        if (targetElement) {
            targetElement.innerHTML = data?.booking?.refund?.offer || 0
        }
        targetElement = doc.getElementById('final');
        if (targetElement) {
            targetElement.innerHTML = (Number(data?.booking?.overallCharges || 0) - (Number(data?.booking?.refund?.offer || 0) ? Number(data?.booking?.refund?.offer || 0) : 0)) > 0 ? Number(data?.booking?.overallCharges || 0) - (Number(data?.booking?.refund?.offer || 0) ? Number(data?.booking?.refund?.offer || 0) : 0) : Number(data?.booking?.overallCharges || 0)
        }
        targetElement = doc.getElementById('total_cost');
        if (targetElement) {
            targetElement.innerHTML = (Number(data?.booking?.totalCostCollected || 0) - (Number(data?.booking?.refund?.offer || 0) ? Number(data?.booking?.refund?.offer || 0) : 0)) > 0 ? (Number(data?.booking?.totalCostCollected || 0) - (Number(data?.booking?.refund?.offer || 0) ? Number(data?.booking?.refund?.offer || 0) : 0)) : Number(data?.booking?.totalCostCollected || 0)
            const updatedHtmlContent = new XMLSerializer().serializeToString(doc);
            downloadFile(updatedHtmlContent)
        }
    }
    const getExisitingData = async () => {
        const response = await Handler({ method: 'get', url: `/booking/detail/${id}` })
        if (response?.success) {
            setData(response?.data)
            setData((prev) => ({ ...prev, booking: { ...response?.data?.booking, overallCharges: response?.data?.booking?.totalCostCollected || 0 } }))
            let diff = ((new Date(response?.data?.booking?.pickupDetails?.pickup).getTime() - new Date(response?.data?.booking?.deliveryDetails?.delivery).getTime()) / 1000) / 3600;
            if (Math.ceil(diff / 12) / 2 == 0.5) {
                setData((prev) => ({ ...prev, rentalFee: (Number(response?.data?.booking?.rentalFee || 0) - Number(response?.data?.booking?.offerPerDay || 0)) + " * " + 1 }))
                setTotalDays(1);
                setPoint({ label: 0, value: 0 })
            } else {
                setTotalDays(Math.floor(Math.ceil(diff / 12) / 2));
                if (Math.ceil(diff / 12) % 2 !== 0) {
                    let to = new Date(response?.data?.booking?.pickupDetails?.pickup)
                    to?.setHours(new Date(response?.data?.booking?.pickupDetails?.pickup)?.getHours() - 2)
                    let diff1 = ((to?.getTime() - new Date(response?.data?.booking?.deliveryDetails?.delivery).getTime()) / 1000) / 3600
                    if (Math.ceil(diff1 / 12) % 2 !== 0) {
                        setPoint({ label: 0.5, value: 0.5 })
                        setData((prev) => ({ ...prev, rentalFee: (Number(response?.data?.booking?.rentalFee || 0) - Number(response?.data?.booking?.offerPerDay || 0)) + " * " + (Math.floor(Math.ceil(diff / 12) / 2)) + " + " + ((Number(response?.data?.booking?.rentalFee || 0) / 2) - (Number(response?.data?.booking?.halfDayOffer || 0))) }))
                    } else {
                        setData((prev) => ({ ...prev, rentalFee: (Number(response?.data?.booking?.rentalFee || 0) - Number(response?.data?.booking?.offerPerDay || 0)) + " * " + (Math.floor(Math.ceil(diff / 12) / 2)) }))
                        setPoint({ label: 0, value: 0 })
                    }
                } else {
                    setData((prev) => ({ ...prev, rentalFee: (Number(response?.data?.booking?.rentalFee || 0) - Number(response?.data?.booking?.offerPerDay || 0)) + " * " + (Math.floor(Math.ceil(diff / 12) / 2)) }))
                    setPoint({ label: 0, value: 0 })
                }
            }
        } else {
            reloadWindowToPath(`/booking/1`)
        }
    }
    const handleSubmit = () => {
        if (gst?.gst != 0 && !gst?.gstType) {
            toast.error("Choose GST type")
        } else {
            let cost = data?.booking?.totalCostCollected;
            if (gst?.gstType === "Inclusive") {
                setData((prevValue) => ({ ...prevValue, booking: { ...data?.booking, totalCostCollected: cost, overallCharges: (cost - (cost * (Number(gst?.gst) / 100)))?.toFixed(3) } }));
            } else {
                setData((prevValue) => ({ ...prevValue, booking: { ...data?.booking, totalCostCollected: ((cost * (Number(gst?.gst) / 100)) + cost).toFixed(3) } }))
            }
            setModal(false)
        }
    }
    useEffect(() => {
        setInvoiceHtml(Invoice);
        getExisitingData();
    }, [])

    return (
        <div>
            <div id="invoiceDiv" className="d-none">{invoiceHtml}</div>
            <div className="justify-content-between d-flex align-items-center back-arrow">
                <div><i onClick={() => navigate(-1)} className="fa-solid fa-arrow-left fs-5 cursor-pointer"></i></div>
                <button onClick={updateInvoiceContent} className="d-flex align-items-center btn btn-sm btn-success">Download <i className="fa-solid fa-download ps-2"></i> </button>
            </div>

            <div className="row justify-content-center">
                <div className="text-center logoImage pt-5 col-sm-12">
                    <img src={logo} alt="logo" />
                </div>
            </div>
            <div className="row text-center">
                <div className="mb-4 mt-4 col-sm-12">
                    <label className="form_heading"> Invoice</label>
                </div>
            </div>
            <div className="mt-2 borderline pb-3 row xs-1 sm-2">
                <div className="col-sm-12 col-md-7">
                    <div className="form_header mb-3">From</div>
                    <div className="row ps-2">
                        <div className="col-sm-4"> <label>MSD Cars,</label> </div>
                    </div>
                    <div className="row ps-2">
                        <div className="col-sm-4"> <label>Chrompet</label> </div>
                    </div>
                    <div className="row ps-2">
                        <div className="col-sm-4"> <label>9790953700</label> </div>
                    </div>
                    <div className="row ps-2">
                        <div className="col-sm-4"> <label>support@msdcars.in</label> </div>
                    </div>
                </div>
                <div className="col-md-5 col-sm-12">
                    <div className="form_header mb-3">To</div>
                    <div className="row ps-2">
                        <div className="col-sm-5"> <label> Booking ID </label> </div>
                        <div className="col-sm-4"> <label>{id} </label> </div>
                    </div>
                    <div className="row ps-2">
                        <div className="col-sm-5"> <label> Customer ID </label> </div>
                        <div className="col-sm-4"> <label> {data?.customer?.customerId} </label> </div>
                    </div>
                    <div className="row ps-2">
                        <div className="col-sm-5"> <label> Name </label> </div>
                        <div className="col-sm-4"><label className="text-capitalize"> {(data?.customer?.firstName || " ") + " " + (data?.customer?.lastName || "")}  </label></div>
                    </div>
                    <div className="row ps-2">
                        <div className="col-sm-5"> <label> Mobile </label> </div>
                        <div className="col-sm-4"><label> {data?.customer?.phone?.length ? (data?.customer?.phone?.filter(element => element?.priority === 1)?.length ? ((data?.customer?.phone?.filter(element => element?.priority === 1)[0]?.code || "") + "-" + (data?.customer?.phone?.filter(element => element?.priority === 1)[0]?.phone || "")) : "") : ""}  </label></div>
                    </div>
                </div>
            </div>
            <div className="mt-4 row xs-1 sm-3 justify-content-between">
                <div className="col-sm-12 col-md-4">
                    <div className="form_header mb-3">Delivery Data</div>
                    <div className="row">
                        <div className="col-sm-4"> <label>Date</label> </div>
                        <div className="col-sm-4"> <label> {data?.booking?.deliveryDetails?.delivery ? moment(new Date(data?.booking?.deliveryDetails?.delivery)).format("DD/MM/YYYY") : ""}  </label> </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-4"> <label>Time</label> </div>
                        <div className="col-sm-4"> <label> {data?.booking?.deliveryDetails?.delivery ? moment(new Date(data?.booking?.deliveryDetails?.delivery)).format("hh:mm A") : ""}  </label> </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-4"> <label>Location</label> </div>
                        <div className="col-sm-4"> <label className="text-capitalize">{data?.booking?.deliveryDetails?.location || ""} </label> </div>
                    </div>
                </div>
                <div className="col-sm-12 col-md-4">
                    <div className="form_header mb-3">Pickup Data</div>
                    <div className="row">
                        <div className="col-sm-4"> <label>Date</label> </div>
                        <div className="col-sm-4"> <label> {data?.booking?.pickupDetails?.pickup ? moment(new Date(data?.booking?.pickupDetails?.pickup)).format("DD/MM/YYYY") : ""}  </label> </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-4"> <label>Time</label> </div>
                        <div className="col-sm-4"> <label> {data?.booking?.pickupDetails?.pickup ? moment(new Date(data?.booking?.pickupDetails?.pickup)).format("hh:mm A") : ""}  </label> </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-4"> <label>Location</label> </div>
                        <div className="col-sm-4"> <label className="text-capitalize"> {data?.booking?.pickupDetails?.location || ""} </label> </div>
                    </div>
                </div>
            </div>
            <div className="my-4 row">
                <div className="col">
                    <div className="overflow">
                        <table className="table table_invoice stripedTable">
                            <thead>
                                <tr>
                                    <th className="tableBackColor">Description </th>
                                    <th className="border_total tableBackColor">Price </th>
                                    <th className="text-center tableBackColor">Amount </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="border_total">Cost per day</td>
                                    <td className="border_total">{data?.rentalFee}</td>
                                    <td className="text-center border_total">{((Number(data?.booking?.rentalFee || 0) - Number(data?.booking?.offerPerDay || 0)) * (totalDays)) + (point?.label === 0.5 ? ((Number(data?.booking?.rentalFee || 0) / 2) - Number(data?.booking?.halfDayOffer || 0)) : 0)}</td>
                                </tr>
                                <tr>
                                    <td className="border_total tableSubHeadingColor">Extra Charges</td>
                                    <td className="border_total tableSubHeadingColor">{Number(data?.booking?.excess?.fuelCharges || 0) + Number(data?.booking?.excess?.kmCharges || 0) + Number(data?.booking?.excess?.timeCharges || 0)}</td>
                                    <td className="text-center border_total tableSubHeadingColor">{Number(data?.booking?.excess?.fuelCharges || 0) + Number(data?.booking?.excess?.kmCharges || 0) + Number(data?.booking?.excess?.timeCharges || 0)}</td>
                                </tr>
                                <tr>
                                    <td className="border_total tableSubHeadingColor">Other Charges</td>
                                    <td className="border_total tableSubHeadingColor">{Number(data?.booking?.excessCharges?.length ? data?.booking?.excessCharges?.reduce((total, num) => total + Number(num?.amount), 0) : 0) + Number(data?.booking?.deliveryDetails?.price || 0) + Number(data?.booking?.pickupDetails?.price || 0) + Number(Number(data?.booking?.fastTag?.start || 0) - Number(data?.booking?.fastTag?.end || 0) > 0 ? (Number(data?.booking?.fastTag?.start || 0) - Number(data?.booking?.fastTag?.end || 0)) : 0)}</td>
                                    <td className="text-center border_total tableSubHeadingColor">{Number(data?.booking?.excessCharges?.length ? data?.booking?.excessCharges?.reduce((total, num) => total + Number(num?.amount), 0) : 0) + Number(data?.booking?.deliveryDetails?.price || 0) + Number(data?.booking?.pickupDetails?.price || 0) + Number(Number(data?.booking?.fastTag?.start || 0) - Number(data?.booking?.fastTag?.end || 0) > 0 ? (Number(data?.booking?.fastTag?.start || 0) - Number(data?.booking?.fastTag?.end || 0)) : 0)}</td>
                                </tr>
                                <tr>
                                    <td className="border_total tableSubHeadingColor">Offer Price</td>
                                    <td className="border_total tableSubHeadingColor">{data?.booking?.refund?.offer || 0}</td>
                                    <td className="text-center border_total tableSubHeadingColor">{data?.booking?.refund?.offer || 0}</td>
                                </tr>
                                <tr className="table_border">
                                    <td className="table_border"></td>
                                    <td className="text-center border-bottom border-left tableBackColor">Final Amount </td>
                                    <td className="text-center border-bottom border-right tableBackColor" style={{ width: '300px' }}>
                                        {(Number(data?.booking?.overallCharges || 0) - (Number(data?.booking?.refund?.offer || 0) ? Number(data?.booking?.refund?.offer || 0) : 0)) > 0 ? Number(data?.booking?.overallCharges || 0) - (Number(data?.booking?.refund?.offer || 0) ? Number(data?.booking?.refund?.offer || 0) : 0) : Number(data?.booking?.overallCharges || 0)}
                                    </td>
                                </tr>
                                <tr className="table_border">
                                    <td className="table_border change-white"></td>
                                    <td className="text-center border-bottom border-left tableBackColor">GST </td>
                                    <td className="text-center border-bottom border-right tableBackColor" style={{ width: '300px' }}>
                                        {gst?.gst || 0}
                                    </td>
                                </tr>
                                <tr className="table_border">
                                    <td className="table_border"></td>
                                    <td className="text-center border-bottom border-left tableBackColor">Total Cost Collected</td>
                                    <td className="text-center border-bottom border-right tableBackColor">{
                                        (Number(data?.booking?.totalCostCollected || 0) - (Number(data?.booking?.refund?.offer || 0) ? Number(data?.booking?.refund?.offer || 0) : 0)) > 0 ? (Number(data?.booking?.totalCostCollected || 0) - (Number(data?.booking?.refund?.offer || 0) ? Number(data?.booking?.refund?.offer || 0) : 0)) : Number(data?.booking?.totalCostCollected || 0)
                                    }</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <Modal header="GST" onShow={modal} footerClassname={'justify-content-center'} toggle={() => setModal(false)} overlayToggle={() => setModal(false)}>
                <div className="mb-3">
                    <label htmlFor="gst" className="form-label"> Enter GST Type </label>
                    <Select
                        onChange={(selectedoption) => {
                            setGst((prev) => ({ ...prev, gst: selectedoption?.value }))
                        }}
                        styles={{
                            control: (base, state) => ({
                                ...base,
                                borderColor: state.isFocused ? "#f16436" : base.borderColor,
                                boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                                "&:hover": {
                                    borderColor: "#f16436"
                                }
                            }),
                            option: (style, state) => ({
                                ...style,
                                backgroundColor: state.isSelected
                                    ? "#f16436"
                                    : (state.isFocused || state.isActive)
                                        ? "#f164361a"
                                        : "white",
                                color: state.isSelected ? "white" : "black"
                            })
                        }}
                        value={{ label: gst?.gst, value: gst?.gst }}
                        options={[{ label: 0, value: 0 }, { label: 5, value: 5 }, { label: 18, value: 18 }, { label: 21, value: 21 }]}
                    />
                </div>
                <div className="mb-3">
                    <label htmlFor="gst" className="form-label"> Enter GST Type </label>
                    <Select
                        onChange={(selectedoption) => {
                            setGst((prev) => ({ ...prev, gstType: selectedoption?.value }))
                        }}
                        styles={{
                            control: (base, state) => ({
                                ...base,
                                borderColor: state.isFocused ? "#f16436" : base.borderColor,
                                boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                                "&:hover": {
                                    borderColor: "#f16436"
                                }
                            }),
                            option: (style, state) => ({
                                ...style,
                                backgroundColor: state.isSelected
                                    ? "#f16436"
                                    : (state.isFocused || state.isActive)
                                        ? "#f164361a"
                                        : "white",
                                color: state.isSelected ? "white" : "black"
                            })
                        }}
                        value={gst?.gstType ? { label: gst?.gstType, value: gst?.gstType } : ""}
                        options={[{ label: "Inclusive", value: "Inclusive" }, { label: "Exclusive", value: "Exclusive" }]}
                    />
                </div>
                <div className="pt-4 pb-2 text-center">
                    <button className="btn btn-success" disabled={render} onClick={handleSubmit}>{render ? <i className="fa-solid fa-spinner fa-spin"></i> : "Submit"}</button>
                </div>
            </Modal>
        </div>
    )
}
export default EditInvoice;